"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var React = require("react");
var Container = function (props) { return (React.createElement("div", { className: 'fileupload-modal-content' }, props.children)); };
exports.Container = Container;
